import Service from './Service';

export default class LocationService extends Service {
    constructor() {
        super();
        this.baseURL = 'dispatchio/location';
    }


}